<template>
    <div class="info-of-workers"  v-if=" $route.params.path==null"> 
        <main-panel>
            <template v-slot:header>
                <h2>{{$route.name}}</h2>
            </template>
        </main-panel>
        <section class="frame-padding">
            <div>
                <input-ms placeholder="Поиск" class="" v-model="searchText" @click="getDoctors(this.searchText,0,12)"></input-ms>
            </div>
            <div class="search__panel">
                <card-doctor mini 
                    v-for ="item in doctors" 
                    :key="item.id" :value="item" 
                    :link="'/workers/person/'+item.id" 
                    >
                </card-doctor>
            </div>
            <div>
                <paginator-ms :count="count" :count-page="length" @change="paginatorChange" @increase-count="increaseCount"></paginator-ms>
            </div>
        </section>
    </div>
    <component :is="$route.params.path!=null?'person':''"/>
</template>
<script>
import cardDoctor from '../components/common/cardDoctor.vue';
import mainPanel from '../components/main/mainPanel.vue';
import inputMs from '../components/common/inputMs.vue';
import paginatorMs from '../components/common/paginatorMs.vue';
// // import personMs from '../components/infoOfWorkers/personMs.vue';
import { defineAsyncComponent } from 'vue'
import axios from 'axios';
export default{
    components:{
        mainPanel,
        inputMs,
        cardDoctor,
        paginatorMs,
        person: defineAsyncComponent(() =>
            import('../components/infoOfWorkers/personMs.vue')
        ),
        // personMs,
    },
    mounted(){       
        this.getDoctors(this.searchText,this.start,this.length)
    },
    methods:{
        increaseCount(length){
            this.getDoctors(this.searchText,0,length)
        },
        paginatorChange(start){
            this.getDoctors(this.searchText,start,this.length)
        },
        getDoctors(searchText ='',start=-1,length=-1){
            this.start = start
            this.length = length
            let searchStr = '?'
            searchStr += start>-1?'start='+start+'&':''
            searchStr +=length>-1?'length='+length+'&':''
            searchStr +=searchText!=''?'searchText='+searchText+'&':''
            axios
                .get('https://mosp51.ru/api/doctor'+searchStr)
                .then(response=>{
                    this.doctors = response.data
                    this.count = response.data[0].count_doc
                })
        }
    },
    data(){
        return{
            doctors:[],
            count:0,
            length:12,
            start:0,
            searchText:''
        }
    },
}
</script>
<style>
.info-of-workers .search-ms___panel_input{
    width:644px;
}
.info-of-workers .search__panel{
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    gap:32px

}
@media (max-width: 1000px){
    .info-of-workers .search-ms___panel_input{
        width:100%;
    }
    .info-of-workers .search__panel {
        margin-top: 24px;
    }
    .info-of-workers .search__panel{
        gap:24px
    }
}
</style>